import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Grid2 from '@mui/material/Grid2';
import { useSelector } from 'react-redux';
import packageJson from '../../../package.json';

const Footer = (props) => {
  const backendVersion = useSelector(state => state.common.backendVersion);
  return (
    <Box sx={{ flexGrow: 1, position: 'fixed', bottom: 0, left: 0, right: 0}} {...props}>
      <Grid2 container spacing={4}  >
        <Grid2 size="grow"  >
            <Typography variant="caption" color="text.secondary" align="left" >
              Copyright &copy; 2014-
              {new Date().getFullYear() + ' '}
              <Link color="inherit" underline="hover" href="https://www.agrecalc.com/">
                SRUC Innovation Ltd
              </Link> • All rights reserved.
            </Typography>
        </Grid2>
        <Grid2 size="grow" justifyContent="right">
            <Typography component='div' variant="caption" color="text.secondary" align="right" mb={1}>
              {`Version: F-${packageJson?.applicationVersions?.versionNumber || ''}${packageJson?.applicationVersions?.commitHash ? '+' + packageJson.applicationVersions?.commitHash : ''}
        / B-${backendVersion?.backendVersion || ''}${backendVersion?.commitHash ? '+' + backendVersion.commitHash : ''} / M-${backendVersion?.calculatorVersion || ''}`}
            </Typography>
        </Grid2>
      </Grid2 >
    </Box>
  );
}

export default Footer
